import {get, filter} from "lodash"

export default (poll, user, formatMessage) => {
  const {votes} = poll

  const winnerVotes = filter(votes.results, (test) => test.user.uuid === user.uuid)

  return formatMessage(
    {id: "recognition.popup.viewPoll.button"},
    {winnerVotes: get(winnerVotes, "length", 0), totalVotes: votes.results.length}
  )
}
